import { getResolvedRef as e } from "@scalar/workspace-store/helpers/get-resolved-ref";
import { deSerializeParameter as t, getExampleFromSchema as n, isParamDisabled as r, serializeContentValue as i, serializeCookieStyle as a, serializeDeepObjectStyle as o, serializeFormStyle as s, serializeFormStyleForCookies as c, serializePipeDelimitedStyle as l, serializeSimpleStyle as u, serializeSpaceDelimitedStyle as d } from "@scalar/workspace-store/request-example";
import { getCookieSerializationError as f } from "@scalar/helpers/http/get-cookie-serialization-error";
import { isObjectLike as p } from "@scalar/helpers/object/is-object";
import { assertReservedPathUrl as m, serializeReservedPathParameter as h } from "@scalar/workspace-store/helpers/encode-path-parameter";
import { getParameterExample as g } from "@scalar/workspace-store/helpers/get-parameter-example";
import { getQuerystringParameter as _, serializeQuerystringParameter as v } from "@scalar/workspace-store/helpers/querystring-parameter";
//#region src/code-example/helpers/operation-to-har/process-parameters.ts
var y = class extends Error {}, b = (t) => (t ?? []).map((t) => e(t)).filter((e) => e !== void 0), x = (e) => "allowReserved" in e && e.allowReserved !== void 0 ? e.allowReserved : "schema" in e && e.schema && typeof e.schema == "object" && "allowReserved" in e.schema ? e.schema.allowReserved === !0 : !1, S = (e) => {
	if (e.in === "header") return {
		style: "simple",
		explode: "explode" in e && e.explode !== void 0 && e.explode
	};
	if (e.in === "cookie") {
		let t = "explode" in e && e.explode !== void 0 ? e.explode : !0;
		return {
			style: "style" in e && e.style === "cookie" ? "cookie" : "form",
			explode: t
		};
	}
	let t = {
		path: "simple",
		query: "form",
		querystring: "form",
		header: "simple",
		cookie: "form"
	}[e.in], n = "style" in e && e.style ? e.style : t;
	return {
		style: n,
		explode: "explode" in e && e.explode !== void 0 ? e.explode : n === "form"
	};
}, C = (i, a, o) => {
	let s = g(i, a), c = s.example;
	if (r(i, c, o)) return;
	if (s.value !== void 0) return t(s.value, i);
	if (!("schema" in i) || !i.schema) return;
	let l = i.in === "path" ? { emptyString: `{${i.name}}` } : {}, u = e(i.schema);
	return u ? n(u, l) : void 0;
}, w = ({ harRequest: e, parameters: t, example: n, defaultDisabled: p, openapiVersion: w }) => {
	let E = [...e.headers], D = [...e.queryString], O = [...e.cookies], k = [], A = e.url, j = !1, M = [], N = [], P = (e, t, n) => {
		x(n) ? M.push(`${encodeURIComponent(e)}=${t}`) : D.push({
			name: e,
			value: t
		});
	}, F = b(t);
	for (let e of F) {
		if (!e.in || !e.name) continue;
		if (e.in === "querystring") {
			let t = _(e, n, { defaultDisabled: p });
			if (t) {
				let e = A.indexOf("#"), n = e === -1 ? "" : A.slice(e), r = (e === -1 ? A : A.slice(0, e)).split("?")[0], i = v(t);
				A = `${r}${i ? `?${i}` : ""}${n}`;
			}
			continue;
		}
		let t = g(e, n);
		if (t.serialized && !r(e, t.example, p)) {
			let n = String(t.value);
			switch (e.in) {
				case "path":
					A = A.replaceAll(`{${e.name}}`, () => n);
					break;
				case "query":
					M.push(n);
					break;
				case "header":
					E.push({
						name: e.name,
						value: n
					});
					break;
				case "cookie":
					N.push(n);
					break;
			}
			continue;
		}
		if (t.mediaSerialized && !r(e, t.example, p)) {
			let n = String(t.value);
			switch (e.in) {
				case "query":
					P(e.name, n, e);
					break;
				case "header":
					E.push({
						name: e.name,
						value: n
					});
					break;
				case "path":
					A = A.replaceAll(`{${e.name}}`, () => encodeURIComponent(n));
					break;
				case "cookie":
					O.push({
						name: e.name,
						value: n
					});
					break;
			}
			continue;
		}
		let m = C(e, n, p);
		if (m === void 0) continue;
		let { style: b, explode: x } = S(e);
		switch (e.in) {
			case "path": {
				let t = w?.startsWith("3.2.") && "schema" in e && e.allowReserved === !0;
				j ||= !!t;
				let n = t ? h(e.name, {
					value: m,
					style: b,
					explode: x
				}) : void 0;
				A = n === void 0 ? T(A, e, m, b, x) : A.replaceAll(`{${e.name}}`, () => n);
				break;
			}
			case "query":
				if ("content" in e && e.content) {
					let t = i(m, Object.keys(e.content)[0] ?? "application/json");
					P(e.name, t, e);
					break;
				}
				switch (b) {
					case "form": {
						let t = s(m, x);
						if (Array.isArray(t)) for (let n of t) P(n.key || e.name, String(n.value), e);
						else P(e.name, String(t), e);
						break;
					}
					case "spaceDelimited": {
						let t = d(m);
						P(e.name, t, e);
						break;
					}
					case "pipeDelimited": {
						let t = l(m);
						P(e.name, t, e);
						break;
					}
					case "deepObject":
						if (Array.isArray(m)) {
							let t = s(m, !0);
							if (Array.isArray(t)) for (let n of t) P(n.key || e.name, String(n.value), e);
							else P(e.name, String(t), e);
						} else {
							let t = o(e.name, m);
							for (let n of t) P(n.key, n.value, e);
						}
						break;
					default: P(e.name, String(m), e);
				}
				break;
			case "header": {
				let t = u(m, x);
				E.push({
					name: e.name,
					value: String(t)
				});
				break;
			}
			case "cookie": {
				let [t, n] = (w ?? "").split("."), r = t === "3" && n === "2" && !("content" in e) ? f(e, m) : void 0;
				if (r) throw new y(r);
				if (b === "cookie") {
					k.push(...a(e.name, m, x));
					break;
				}
				let i = c(m, x);
				if (Array.isArray(i)) for (let t of i) {
					let n = t.key || e.name, r = t.value === null ? "null" : String(t.value);
					O.push({
						name: n,
						value: r
					});
				}
				else {
					let t = i === null ? "null" : String(i);
					O.push({
						name: e.name,
						value: t
					});
				}
				break;
			}
		}
	}
	if (k.length || N.length) {
		let e = [
			...O.map((e) => `${encodeURIComponent(e.name)}=${encodeURIComponent(e.value)}`),
			...k.map((e) => `${e.name}=${e.value}`),
			...N
		].join("; "), t = E.find((e) => e.name.toLowerCase() === "cookie");
		t ? E.splice(E.indexOf(t), 1, {
			...t,
			value: t.value ? `${t.value}; ${e}` : e
		}) : E.push({
			name: "Cookie",
			value: e
		});
	}
	if (M.length) {
		let e = A.indexOf("#"), t = e < 0 ? "" : A.slice(e), n = e < 0 ? A : A.slice(0, e);
		A = `${n}${n.includes("?") ? "&" : "?"}${M.join("&")}${t}`;
	}
	return j && m(A), {
		url: A,
		headers: E,
		queryString: D,
		cookies: k.length || N.length ? [] : O,
		hasCookieStyleEntries: k.length > 0 || N.length > 0,
		...M.length ? { hasSerializedQuery: !0 } : {}
	};
}, T = (e, t, n, r, i) => {
	switch (r) {
		case "matrix":
			if (i) {
				if (Array.isArray(n)) {
					let r = n.map((e) => `${t.name}=${e}`).join(";");
					return e.replace(`{;${t.name}}`, `;${r}`);
				}
				if (p(n)) {
					let r = Object.entries(n).map(([e, t]) => `${e}=${t}`).join(";");
					return e.replace(`{;${t.name}}`, `;${r}`);
				}
				return e.replace(`{;${t.name}}`, `;${t.name}=${n}`);
			}
			if (Array.isArray(n)) return e.replace(`{;${t.name}}`, `;${t.name}=${n.join(",")}`);
			if (p(n)) {
				let r = Object.entries(n).map(([e, t]) => `${e},${t}`).join(",");
				return e.replace(`{;${t.name}}`, `;${t.name}=${r}`);
			}
			return e.replace(`{;${t.name}}`, `;${t.name}=${n}`);
		case "label":
			if (i) {
				if (Array.isArray(n)) return e.replace(`{.${t.name}}`, `.${n.join(".")}`);
				if (p(n)) {
					let r = Object.entries(n).map(([e, t]) => `${e}=${t}`).join(".");
					return e.replace(`{.${t.name}}`, `.${r}`);
				}
				return e.replace(`{.${t.name}}`, `.${n}`);
			}
			if (Array.isArray(n)) return e.replace(`{.${t.name}}`, `.${n.join(",")}`);
			if (p(n)) {
				let r = Object.entries(n).map(([e, t]) => `${e},${t}`).join(",");
				return e.replace(`{.${t.name}}`, `.${r}`);
			}
			return e.replace(`{.${t.name}}`, `.${n}`);
		case "simple": {
			let r = u(n, i);
			return e.replace(`{${t.name}}`, String(r));
		}
		default: return e.replace(`{${t.name}}`, String(n));
	}
};
//#endregion
export { y as CookieSerializationError, w as processParameters };

//# sourceMappingURL=process-parameters.js.map